import Modal from '@rd-web-markets/shared/dist/util/Modal';
import React from 'react';
const TemplateUploadErrorsModal = _ref => {
  let {
    title,
    body,
    onHide,
    show
  } = _ref;
  const importErrorsModalBody = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, body);
  };
  return /*#__PURE__*/React.createElement(Modal, {
    show: show,
    size: "lg",
    title: title,
    renderBody: () => importErrorsModalBody(),
    onHide: onHide
  });
};
export default TemplateUploadErrorsModal;